export default "__VITE_ASSET__CcZaBlSk__"